/**
 * Typer for ExternalSystem-administrasjon (vareheis-/eksternsystem-konfig).
 * Speiler ExternalSystemAdminDTOs.cs. ApiToken eksponeres aldri fra API-et —
 * kun hasApiToken; token settes/erstattes via create/update-requestene.
 */

export interface ExternalSystemAdmin {
  id: number;
  companyNo: string;
  externalSystemID: number;
  externalCustomID?: string | null;
  description1?: string | null;
  operatorID?: string | null;
  profileID?: string | null;
  /** 45 = Til pakking, 50 = Klar for eksport (direkteavslutning) */
  importPListStatus?: number | null;
  activeYesNo: boolean;
  /** Bitmaske: 1=plukk eksport, 2=plukk ferdigmelding (4/8/32 = senere faser) */
  docTypeActive: number;
  providerKey?: string | null;
  apiBaseUrl?: string | null;
  hasApiToken: boolean;
  confirmationNextId: number;
  updatedBy?: string | null;
  lastUpdate?: string | null;
  createdBy?: string | null;
  created?: string | null;
}

export interface CreateExternalSystemAdminRequest {
  externalSystemID: number;
  externalCustomID?: string;
  description1?: string;
  operatorID?: string;
  profileID?: string;
  importPListStatus?: number;
  activeYesNo: boolean;
  docTypeActive: number;
  providerKey?: string;
  apiBaseUrl?: string;
  apiToken?: string;
}

export interface UpdateExternalSystemAdminRequest {
  externalSystemID?: number;
  externalCustomID?: string;
  description1?: string;
  operatorID?: string;
  profileID?: string;
  importPListStatus?: number;
  activeYesNo?: boolean;
  docTypeActive?: number;
  providerKey?: string;
  apiBaseUrl?: string;
  /** undefined = behold eksisterende token, tom streng = fjern, verdi = erstatt */
  apiToken?: string;
  confirmationNextId?: number;
}

/** Kjente providere (må matche VerticalLiftProviderKeys i backend) */
export const EXTERNAL_SYSTEM_PROVIDERS = ['Shark', 'MockLift'] as const;

/** DocTypeActive-bits som er implementert i fase 1 */
export const DOC_TYPE_BITS = {
  pickExport: 1,
  pickConfirmation: 2
} as const;
